import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { ThemeMode } from '../ui/theme/tokens.js'

export type ThemePreference = ThemeMode | 'system'
export type Density = 'compact' | 'standard' | 'comfortable'

interface UiState {
  themePreference: ThemePreference
  sidebarCollapsed: boolean
  density: Density
  setThemePreference: (value: ThemePreference) => void
  toggleSidebar: () => void
  setDensity: (value: Density) => void
}

/**
 * État d'interface uniquement (§7.9). Les données métier ne passent JAMAIS
 * par ce store : elles vivent dans IndexedDB via la couche de réplique locale.
 */
export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      themePreference: 'system',
      sidebarCollapsed: false,
      density: 'standard',
      setThemePreference: (themePreference) => set({ themePreference }),
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setDensity: (density) => set({ density }),
    }),
    { name: 'iobiz.ui' },
  ),
)

export function resolveThemeMode(preference: ThemePreference): ThemeMode {
  if (preference !== 'system') return preference
  return typeof window !== 'undefined' &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light'
}
